import { MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToSection } from "@/lib/scroll";
import { useLanguage } from "@/context/LanguageContext";
import { singleWhatsappUrl, whatsappConfigured } from "@/context/CartContext";
import { getProduct, flagshipId, getSize, defaultSizeId } from "@/config/products";

export default function FinalCta() {
  const { t } = useLanguage();
  const waOn = whatsappConfigured();
  const product = getProduct(flagshipId);
  const size = getSize(defaultSizeId);

  const order = () =>
    window.open(singleWhatsappUrl({ productKey: product.key, size: size.label, qty: 1, price: size.price }, t), "_blank");

  return (
    <section data-testid="final-cta-section" className="bg-[#111111] py-24">
      <Reveal className="mx-auto max-w-2xl px-6 text-center">
        <h2 className="font-serif-display text-4xl font-medium text-white sm:text-5xl">{t.finalCta.title}</h2>
        <p className="mx-auto mt-4 max-w-md font-body text-sm text-white/65">{t.finalCta.subtitle}</p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <button
            data-testid="final-shop"
            onClick={() => scrollToSection("#flagship")}
            className="rounded-full bg-white px-8 py-3.5 font-body text-sm font-medium text-[#111] transition-transform duration-300 hover:scale-[1.03]"
          >
            {t.finalCta.primary}
          </button>
          {waOn && (
            <button
              data-testid="final-whatsapp"
              onClick={order}
              className="flex items-center gap-2 rounded-full border border-white/40 px-8 py-3.5 font-body text-sm text-white transition-colors duration-200 hover:bg-white/10"
            >
              <MessageCircle className="h-4 w-4" /> {t.finalCta.whatsapp}
            </button>
          )}
        </div>
      </Reveal>
    </section>
  );
}
